module.exports = __webpack_public_path__ + "static/img/img_logo_6.ac507747.png";